module.exports = __webpack_public_path__ + "img/4d8d5a03aa857e65528b95a714d52c22.svg";